module.exports = __webpack_public_path__ + "media/img/event/Free-SBT-Banner-f8fe195c1e7ec6f36e637425f9b7f2de.jpg";